import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CreateChannelContext } from "../../../../context/CreateChannelContext";
import { ChannelState, getChannelStatusString } from "../../../../models/SKChannel";

interface HistoryNavigatorProps {
  title?: string;
  chanelStatus?: ChannelState;
  docId: string;
}

export default function HistoryNavigator({ title, chanelStatus, docId }: HistoryNavigatorProps) {
  const { channelData, updateChannelData } = useContext(CreateChannelContext);
  //const [editable, setEditable] = useState<boolean>(true);
  const [imgSrc, setImgSrc] = useState<string>("/icons/Addsign.png");
  const navigate = useNavigate();

  // useEffect(() => {
  //   if (channelData.status === ChannelState.DRAFT) {
  //     setEditable(true);
  //   } else {
  //     setEditable(false);
  //   }
  //   if (channelData.status) {
  //     setImgSrc(editable ? "/icons/CheckItem.png" : "/icons/checkeditem.png");
  //   }
  // }, [docId, editable]);

  return (
    <div className="relative w-full min-w-[200px]">
      <div className="flex items-center pb-[10px]">
        <span className="content_title">{title}</span>
      </div>
      <div
        id="content-item"
        className="cursor-pointer input-content-topic"
        tabIndex={0}
        //onClick={() => navigate("../history", { state: { editable } })}
        onClick={() => {
          docId && navigate("../history", { state: { channelId: docId } });
        }}
      >
        <div className="flex items-center justify-between w-full">
          <div id="topic" className="flex input-content-topic-text">
            View Status History
          </div>

          <div id="title" className="flex m-[15px]">
            <div className="input-content-topic-title">{getChannelStatusString(channelData.status, channelData.subStatus, true)}</div>
            {/* <span className="input-plus-topic ml-[5px]">
              <img
                src={imgSrc}
                className="object-contain w-[19px] h-[20px] min-w-5"
                alt="Certification status"
              />
            </span> */}
          </div>
        </div>
      </div>
    </div>
  );
}
